import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { clearLocalStorage } from '../../helper/storage'
import { axiosInstance } from '../../axios/interceptor'

export const addProperty = createAsyncThunk('property/add', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/properties/create-properties`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const editProperty = createAsyncThunk('property/edit', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/properties/update-properties/${data?.property_id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const deleteProperty = createAsyncThunk('property/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.delete(`/properties/delete-properties/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllProperty = createAsyncThunk('property/all', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/properties/get-all-properties`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getPropertyByID = createAsyncThunk('property/get', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/properties/get-properties/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const addiCal = createAsyncThunk('property/iCal/add', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/client/icallink/create-icallinks`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const editiCal = createAsyncThunk('property/iCal/edit', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/properties/update-properties/${data?.property_id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllTasks = createAsyncThunk('property/allTask', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/task/get-all-task`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getAllConsumables = createAsyncThunk('property/allConsumables', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/consumable/get-all-consumable`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const createManualPropertySchedule = createAsyncThunk('property/schedule/create', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/property-schedule/create-property-schedule`, data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const editManualPropertySchedule = createAsyncThunk('property/schedule/edit', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/property-schedule/update-property-schedule/${data?.scheduleID}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getPropertyScheduleById = createAsyncThunk('property/schedule/getById', async (data, { rejectWithValue }) => {
  const params = data.params
  try {
    const response = await axiosInstance.get(`/property-schedule/get-property-schedule-by-property-id/${data?.property_id}`, { params })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})
export const getSchedulePropertyDataById = createAsyncThunk('property/scheduleData/getById', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/property-schedule/get-property-schedule/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const deletePropertySchedule = createAsyncThunk('property/schedule/delete', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.delete(`/property-schedule/delete-property-schedule/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getTooltipIcal = createAsyncThunk('property/get-tooltip', async (params, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/ical-tool-tip/get-all-ical-tool-tips`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

// Edit Main Cleaner
export const editMainCleaner = createAsyncThunk('property/mainCleaner/edit', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/properties/update-main-cleaner/${data?.property_id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

// Edit Total Value
export const editTotalValue = createAsyncThunk('property/totalValue/edit', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/properties/update-total-value/${data?.property_id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

// Edit Cleaner Service Value
export const editCleanerServiceValue = createAsyncThunk('property/cleanerServiceValue/edit', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/properties/update-cleaner-service-value/${data?.property_id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const cancelPropertyScheduleRequest = createAsyncThunk('property/cancel-property-schedule-request', async (payload, { rejectWithValue }) => {
 
  try {
    const response = await axiosInstance.put(`/property-schedule/cancel-property-schedule-request/${payload?.property_id}`, {
      cancellation_charge: payload?.cancellation_charge
    })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const completePropertyScheduleRequest = createAsyncThunk('property/complete-property-schedule-request', async (data, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.put(`/property-schedule/complete-property-schedule-request/${data?.property_id}`, data?.data)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const getScheduleCompleteDetails = createAsyncThunk('property/scheduleData/complete/getById', async (id, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`/cleaning/get-cleaning-report-by-property-schedule/${id}`)
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const acknowledgeCleaningCancelRequest = createAsyncThunk('cleaning/acknowledge-cleaning-cancel-request', async (payload, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.post(`/cleaning/acknowledge-cleaning-cancel-request/${payload?.cleaning_id}`, {
      isChargeCancellation: payload?.isChargeCancellation
    })
    return response
  } catch (error) {
    return rejectWithValue(error)
  }
})

const initialState = {
  isLoading: false,
  allProperty: [],
  allTasks: [],
  allConsumables: [],
  allScheduledProperties: [],
  scheduledProperties: null,
  scheduledPropertiesComplete: null,
  getProperty: null,
  property: null,
  iCalData: null,
  error: null
}

const propertySlice = createSlice({
  name: 'property',
  initialState,
  reducers: {
    resetAuthState: (state) => {
      state.user = null
      clearLocalStorage()
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addProperty.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addProperty.fulfilled, (state, action) => {
        state.isLoading = false
        state.property = action.payload?.data?.data
      })
      .addCase(addProperty.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(editProperty.pending, (state) => {
        state.isLoading = true
      })
      .addCase(editProperty.fulfilled, (state) => {
        state.isLoading = false
        // state.property = action.payload?.data?.data
      })
      .addCase(editProperty.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(deleteProperty.pending, (state) => {
        state.isLoading = true
      })
      .addCase(deleteProperty.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(deleteProperty.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAllProperty.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllProperty.fulfilled, (state, action) => {
        state.isLoading = false
        state.allProperty = action.payload?.data?.data
      })
      .addCase(getAllProperty.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getPropertyByID.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getPropertyByID.fulfilled, (state, action) => {
        state.isLoading = false
        state.getProperty = action.payload?.data?.data
      })
      .addCase(getPropertyByID.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(addiCal.pending, (state) => {
        state.isLoading = true
      })
      .addCase(addiCal.fulfilled, (state, action) => {
        state.isLoading = false
        state.property = action.payload?.data?.data
      })
      .addCase(addiCal.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(editiCal.pending, (state) => {
        state.isLoading = true
      })
      .addCase(editiCal.fulfilled, (state, action) => {
        state.isLoading = false
        state.property = action.payload?.data?.data
      })
      .addCase(editiCal.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAllTasks.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllTasks.fulfilled, (state, action) => {
        state.isLoading = false
        state.allTasks = action.payload?.data?.data
      })
      .addCase(getAllTasks.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getAllConsumables.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getAllConsumables.fulfilled, (state, action) => {
        state.isLoading = false
        state.allConsumables = action.payload?.data?.data
      })
      .addCase(getAllConsumables.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getPropertyScheduleById.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getPropertyScheduleById.fulfilled, (state, action) => {
        state.isLoading = false
        state.allScheduledProperties = action.payload?.data?.data
      })
      .addCase(getPropertyScheduleById.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getSchedulePropertyDataById.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getSchedulePropertyDataById.fulfilled, (state, action) => {
        state.isLoading = false
        state.scheduledProperties = action.payload?.data?.data
      })
      .addCase(getSchedulePropertyDataById.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(deletePropertySchedule.pending, (state) => {
        state.isLoading = true
      })
      .addCase(deletePropertySchedule.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(deletePropertySchedule.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(createManualPropertySchedule.pending, (state) => {
        state.isLoading = true
      })
      .addCase(createManualPropertySchedule.fulfilled, (state, action) => {
        state.isLoading = false
        state.property = action.payload?.data?.data
      })
      .addCase(createManualPropertySchedule.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(editManualPropertySchedule.pending, (state) => {
        state.isLoading = true
      })
      .addCase(editManualPropertySchedule.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(editManualPropertySchedule.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getTooltipIcal.pending, (state) => {
        state.isLoading = true
      })
      .addCase(getTooltipIcal.fulfilled, (state, action) => {
        state.isLoading = false
        state.iCalData = action?.payload?.data?.data
      })
      .addCase(getTooltipIcal.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(editMainCleaner.pending, (state) => {
        state.isLoading = true
      })
      .addCase(editMainCleaner.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(editMainCleaner.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(editCleanerServiceValue.pending, (state) => {
        state.isLoading = true
      })
      .addCase(editCleanerServiceValue.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(editCleanerServiceValue.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(editTotalValue.pending, (state) => {
        state.isLoading = true
      })
      .addCase(editTotalValue.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(editTotalValue.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(cancelPropertyScheduleRequest.pending, (state) => {
        state.isLoading = true
      })
      .addCase(cancelPropertyScheduleRequest.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(cancelPropertyScheduleRequest.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(completePropertyScheduleRequest.pending, (state) => {
        state.isLoading = true
      })
      .addCase(completePropertyScheduleRequest.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(completePropertyScheduleRequest.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(getScheduleCompleteDetails.pending, (state) => {
        state.isLoading = true
        state.scheduledPropertiesComplete = []
      })
      .addCase(getScheduleCompleteDetails.fulfilled, (state, action) => {
        state.isLoading = false
        state.scheduledPropertiesComplete = action.payload?.data?.data
      })
      .addCase(getScheduleCompleteDetails.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
      .addCase(acknowledgeCleaningCancelRequest.pending, (state) => {
        state.isLoading = true
      })
      .addCase(acknowledgeCleaningCancelRequest.fulfilled, (state) => {
        state.isLoading = false
      })
      .addCase(acknowledgeCleaningCancelRequest.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error.message
      })
  }
})

export const { resetAuthState } = propertySlice.actions
export default propertySlice.reducer
